Browser = require '@trello/browser'
Dates = require 'app/scripts/lib/dates'
DueDateHelpers = require 'app/scripts/views/internal/due-date-helpers'
Label = require 'app/scripts/models/label'
PluginModelSerializer = require 'app/scripts/views/internal/plugins/plugin-model-serializer'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
templates = require 'app/scripts/views/internal/templates'
_ = require 'underscore'
labelTemplate = require 'app/scripts/views/templates/label'
pluginCoverWithDefaults = require 'app/scripts/lib/plugins/plugin-cover-with-defaults'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
t = require('app/scripts/views/internal/teacup-with-helpers')('badge')
l = require 'app/scripts/lib/localize'
{ featureFlagClient } = require '@trello/feature-flag-client'
Util = require 'app/scripts/lib/util'
{ UnsplashTracker } = require '@trello/unsplash'

badgesTemplate = t.renderable ({
  archived
  attachments
  attachmentsByType
  checkItems
  checkItemsChecked
  comments
  description
  due
  dueComplete
  location
  notifications
  subscribed
  viewingMemberVoted
  votes
  isOnBoardTemplate
  hideVotes
  isCardTemplate
  showDueCompleteCheckbox
}) ->
  if isCardTemplate
    t.div '.badge.is-template', { title: l('badge.template') }, ->
      t.span '.badge-icon.icon-sm.icon-template-card'
      t.span '.badge-text', ->
        t.format 'template'
  if notifications
    t.div '.badge.is-unread-notification', { title: l('badge.notifications') }, ->
      t.span '.badge-icon.icon-sm.icon-notification'
      t.span '.badge-text', ->
        t.text notifications
  if subscribed
    t.div '.badge.is-icon-only', { title: l("badge.watch") }, ->
      t.span '.badge-icon.icon-sm.icon-subscribe'

  if votes > 0 && !isCardTemplate
    if !hideVotes
      t.div '.badge', { title: l('badge.votes'), class: t.classify('is-voted': viewingMemberVoted) }, ->
        t.span '.badge-icon.icon-sm.icon-vote'
        t.span '.badge-text', ->
          t.text votes
    else if hideVotes && viewingMemberVoted
      t.div '.badge', { title: l('badge.votes'), class: t.classify('is-voted': viewingMemberVoted) }, ->
        t.span '.badge-icon.icon-sm.icon-vote'

  if due && !isCardTemplate
    t.div '.badge.js-due-date-badge', { title: DueDateHelpers.titleForDueDate(due, dueComplete), class: t.classify({
      "#{DueDateHelpers.classForDueDate(due, dueComplete)}": true
      'mod-due-date': showDueCompleteCheckbox
    }) }, ->
      t.span '.badge-icon.icon-sm.icon-clock.badge-due-icon'
      t.input '.mod-due-complete-checkbox', { type: 'checkbox', checked: dueComplete }
      t.span '.badge-text.js-due-date-text', ->
        t.text Dates.toDateString(due)

  if description
    t.div '.badge.is-icon-only', { title: l('badge.description') }, ->
      t.span '.badge-icon.icon-sm.icon-description'

  # Hide comments badge on templates, since we're not showing comments on card detail
  if comments > 0 && !isOnBoardTemplate
    t.div '.badge', { title: l('badge.comments') }, ->
      t.span '.badge-icon.icon-sm.icon-comment'
      t.span '.badge-text', ->
        t.text comments

  trelloAttachments = if attachmentsByType
    attachmentsByType.trello.board + attachmentsByType.trello.card
  else
    0

  attachments = attachments - trelloAttachments
  if attachments > 0
    t.div '.badge', { title: l('badge.attachments') }, ->
      t.span '.badge-icon.icon-sm.icon-attachment'
      t.span '.badge-text', ->
        t.text attachments

  if trelloAttachments > 0
    t.div '.badge', { title: l('badge.trello attachments') }, ->
      t.span '.badge-icon.icon-sm.icon-board'
      t.span '.badge-text', ->
        t.text trelloAttachments

  if checkItems > 0
    t.div '.badge', { title: l('badge.checkitems'), class: t.classify('is-complete': checkItemsChecked == checkItems) }, ->
      t.span '.badge-icon.icon-sm.icon-checklist'
      t.span '.badge-text', ->
        t.text checkItemsChecked
        t.text "/"
        t.text checkItems

  if archived
    t.div '.badge', { title: l('badge.archived.title') }, ->
      t.span '.badge-icon.icon-sm.icon-archive'
      t.span '.badge-text', ->
        t.text l('badge.archived.text')

  if location
    t.div '.badge', { title: l('badge.location') }, ->
      t.span '.badge-icon.icon-sm.icon-location'

# This whole file shouldn't exist. It only exists because the *previous*
# way that the QuickCardEditor was implemented was even worse. But I'm not
# going to fight that fight today. This is me taking the easy way out.

module.exports =
  clearCover: ->
    @$el.removeClass('is-covered')
    @$('.js-card-stickers').css('height', '')
    @$('.js-card-cover')
    .css
      'background-origin': ''
      'background-image': ''
      'background-color': ''
      'height': ''
      'padding': ''
    .removeClass('is-no-preview-size color-card-cover')
    @clearColorCover()

  clearColorCover: ->
    @$('.js-card-cover').removeClass (index, className) ->
      return (className.match(/\bcolor-card-cover-\S+/g) || []).join(' ')

  renderCover: ->
    if !@model.getBoard().getPref('cardCovers') || @onCalendar
      # card covers are disabled on the board or user is on calendar
      @clearCover()
      @clearFullCover()
      return @

    if !@model.hasCover()
      # card doesn't (or no longer) has a native cover
      @renderPluginCover()
      return @

    { idAttachment, idUploadedBackground, color, scaled, edgeColor, sharedSourceUrl, size } = @model.get('cover')

    $cardCover = @$('.js-card-cover')
    $cardStickers = @$('.js-card-stickers')

    @clearColorCover()

    if size == 'full' && @shouldRenderFullCover
      return @renderFullCover()
    else
      @clearFullCover()

    if color && @colorCoversFlagEnabled
      calculatedHeight = if @model.hasStickers() then 64 else 32
      $cardCover
        .css
          'background-color': ''
          'background-image': ''
          'background-size': ''
          height: calculatedHeight
        .toggleClass('is-no-preview-size', false)
      $cardCover.addClass("color-card-cover color-card-cover-#{color}")
      $cardStickers.css('height', calculatedHeight)
    else if idAttachment || idUploadedBackground
      minWidth = if Browser.isHighDPI() then 600 else 300
      preview =
        Util.smallestPreviewBiggerThan(scaled, minWidth) ?
        Util.biggestPreview(scaled)

      # Not sure how this can happen but supporting it anyway just in case it's a legacy thing.
      if !preview? && idAttachment
        attachmentCover = @model.attachmentList.get(@model.get('idAttachmentCover'))
        preview =
          url: attachmentCover.get('url')

      $cardCover
        .css
          'background-color': edgeColor ? 'transparent'
          'background-image': "url(\"#{preview.url}\")"
        .toggleClass('is-no-preview-size', !preview?)

      if preview?
        maxHeight = Math.min(preview.height, 260) # An arbitrarily chosen number

        # 245 is the effective width of the card (including padding and margin
        # and scrollbars)
        calculatedHeight = preview.height * 245 / preview.width
        if calculatedHeight <= maxHeight
          $cardCover
            .css({
              height: calculatedHeight
              'background-size': 'cover'
            })
          $cardStickers.css('height', calculatedHeight)
        else
          $cardCover.css({
            height: maxHeight,
            'background-size': 'contain'
          })
          $cardStickers.css('height', maxHeight)

        if idUploadedBackground
          UnsplashTracker.trackOncePerInterval(sharedSourceUrl)

    @$el.addClass('is-covered')

    @

  clearFullCover: ->
    @$('.js-card-stickers').css('height', '')
    @$el.removeClass (index, className) ->
      classesToRemove = (className.match(/\bcolor-card-cover-\S+/g) || [])
      classesToRemove.push('full-cover-list-card')
      classesToRemove.push('full-cover-list-card-dark')

      return classesToRemove.join(' ')

    @$el
      .css
        'background-size': ''
        'background-image': ''
        'height': ''

  renderFullCover: ->
    @clearFullCover()

    { idAttachment, idUploadedBackground, color, scaled, edgeColor, sharedSourceUrl, brightness } = @model.get('cover')

    @$el.addClass('full-cover-list-card')

    if brightness == 'dark'
      @$el.addClass('full-cover-list-card-dark')

    if color && @colorCoversFlagEnabled
      @$el.addClass("color-card-cover color-card-cover-#{color}")
    else
      minWidth = if Browser.isHighDPI() then 600 else 300
      preview =
        Util.smallestPreviewBiggerThan(scaled, minWidth) ?
        Util.biggestPreview(scaled)

      @$el
        .css
          'background-image': "url(\"#{preview.url}\")"
          'background-size': 'cover'

      maxHeight = Math.min(preview.height, 260)
      calculatedHeight = preview.height * 245 / preview.width


      if calculatedHeight <= maxHeight
        cardHeight = calculatedHeight
      else
        cardHeight = maxHeight

      @$el
        .css({
          height: cardHeight
        })

      @$('.js-card-stickers').css('height', cardHeight)
    @

  renderPluginCover: ->
    @waitForId @model, =>
      PluginRunner.one
        command: 'card-cover'
        board: @model.getBoard()
        card: @model
        list: @model.getList()
        timeout: 10000
        options:
          attachments: PluginModelSerializer.attachments(@model.attachmentList.models, ['id', 'url'])
          cardDetail: false
      .then (pluginCover) =>
        # to avoid race conditions since this was async, check if there is
        # a native cover again
        if @model.hasCover()
          return
        if !pluginValidators.isValidCover(pluginCover)
          throw new Error('Invalid cover supplied')
        sanitizedCover = pluginCoverWithDefaults(pluginCover)
        # update the CSS
        $cardCover = @$('.js-card-cover')
        $cardCover
          .css
            'background-origin': 'content-box'
            'background-color': sanitizedCover.edgeColor
            'background-image': "url(\"#{sanitizedCover.url}\")"
            'background-position': sanitizedCover.position
            'background-repeat': 'no-repeat'
            'background-size': sanitizedCover.size
            'height': "#{sanitizedCover.height}px"
            'padding': sanitizedCover.padding
          .removeClass('is-no-preview-size')
        @$('.js-card-stickers').css('height', sanitizedCover.stickerHeight)
        @$el.addClass('is-covered')
      .catch =>
        # to avoid race conditions since this was async, check if there is
        # a native cover again
        if !@model.hasCover()
          @clearCover()
          @clearFullCover()

  getBadgesHtml: ->
    badges = @model.get('badges') ? {}
    dueCompleteCheckboxFlagEnabled =
        featureFlagClient.get('remarkable.card-front-due-complete-checkbox', false)

    badgesTemplate({
      subscribed: badges.subscribed
      description: badges.description
      comments: badges.comments
      attachments: badges.attachments
      attachmentsByType: badges.attachmentsByType
      checkItems: badges.checkItems
      checkItemsChecked: badges.checkItemsChecked
      hideVotes: !!@model.getBoard().get('prefs').hideVotes
      votes: badges.votes
      viewingMemberVoted: badges.viewingMemberVoted
      due: @model.get('due')
      dueComplete: @model.get('dueComplete')
      notifications:
        _.filter @modelCache.all('Notification'), (notification) =>
          notification.get('unread') &&
          @model.id? &&
          notification.get('data')?.card?.id == @model.id
        .length
      archived: @model.get('closed')
      location: badges.location && @model.getBoard()?.isMapPowerUpEnabled()
      isOnBoardTemplate: @model.isOnBoardTemplate()
      isCardTemplate: !!@model.get('isTemplate')
      showDueCompleteCheckbox: dueCompleteCheckboxFlagEnabled
    })

  renderBadges: ->
    @$('.js-badges').html @getBadgesHtml()
    @

  updateDueDate: ->
    due = @model.get('due')
    dueComplete = @model.get('dueComplete')

    badgeElem = @el.querySelector('.js-due-date-badge')
    badgeText = @el.querySelector('.js-due-date-text')

    if badgeElem && badgeText
      currentTitle = badgeElem.getAttribute('title')
      newTitle = DueDateHelpers.titleForDueDate(due, dueComplete)

      # If no update is necessary, return early
      if currentTitle == newTitle
        return @

      badgeElem.setAttribute('title', newTitle)
      oldClass = badgeElem.classList.value.split(' ').pop()
      badgeElem.classList.replace(oldClass, DueDateHelpers.classForDueDate(due, dueComplete))
      badgeText.innerText = Dates.toDateString(due)
    @

  toggleDueDateComplete: (e) ->
    Util.stop(e)

    if !featureFlagClient.get('remarkable.card-front-due-complete-checkbox', false)
      return

    newValue = !@model.get('dueComplete')
    @model.update({
      dueComplete: newValue
    })

  renderMembers: (e) ->
    html = ""
    org = @model.getBoard().getOrganization()
    memberHtmls = for member in @model.memberList.models by -1
      @getMemberOnCardHtml member
    @$('.js-list-card-members').empty().append memberHtmls.join('')
    @

  labelsData: ->
    _.chain(@model.getLabels())
      .sort(Label.compare)
      .map (label) => @model.dataForLabel(label)
      .filter (uiLabel) -> !_.isEmpty(uiLabel.color)
      .value()

  renderLabels: ->
    labelsHtml = for label in @labelsData()
      data = label
      data.extraClasses = ['mod-card-front']
      labelTemplate(data)

    @$('.js-card-labels').empty().append(labelsHtml)
    @
